import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, Outlet } from 'react-router-dom';
import { Box } from '@mui/material';

import Header from '../../Header';
import Modal from "../../Modals";
import AppContainer from '../../Container/AppContainer';
import AppPreLoadingScreen from '../../AppPreLoadingScreen';

import useAuthWithRoles from '../../../hooks/use-auth';

const MainLayout = ({ children }) => {
  const location = useLocation()
  useAuthWithRoles()
  const showPreLoadingScreen = useSelector(state => state.showPreLoadingScreen)

  const [scrollPositions, setScrollPositions] = useState({});

   // Save scroll position before route changes
   useEffect(() => {
    const saveScrollPosition = () => {
      const { pathname } = window?.location;
      if (window && pathname === '/') {
        setScrollPositions((prev) => ({
          ...prev,
          [location.pathname]: window.scrollY,
        }));
      }
    };
    if(window?.location.pathname === '/') {
      setTimeout(() => {
        const savedPosition = scrollPositions[location.pathname];
        window.scrollTo(0, savedPosition);
        window.addEventListener('scroll', saveScrollPosition);
      }, 1100);
    } else {
      window.scrollTo(0, 0);
      window.removeEventListener('scroll', saveScrollPosition);
    }
  }, [location.pathname]);

  if (showPreLoadingScreen) return (
    <AppPreLoadingScreen />
  )

  return (
    <Box 
      sx={{
        width: '100%',
        minHeight: '100vh',
        position: 'relative',
        backgroundColor: 'background.default',
        backgroundSize: 'cover',
        mt: '80px'
      }}
    >
      <Header />
      <AppContainer>
        {children}
      </AppContainer>
      <Modal />
      {/* <AppNotificationButton /> */}
      {/* <AppMobileBottomMenu /> */}
      <Box>
        <Outlet />
      </Box>
    </Box>
  )
}

export default MainLayout;